import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import Select from 'react-select';
import { getTimezone } from '../../../helpers/helperFunction';
import CloseIcon from '../../SVG/CloseIcon';
import { CampaignGreenIconSVG } from '../../SVG/CampaignGreenIconSVG';
import SendScheduleConfirmModel from '../../../components/Admin/SendScheduleConfirmModel';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const ScheduleModal = ({
  show,
  onClose,
  handleScheduleLater,
  campaign_form_fields,
  setCampaignFormFields,
}) => {
  const { timezone, schedule_time } = campaign_form_fields;
  const [showConfirmModel, setShowConfirmModel] = useState(false);

  const handleCampaignFormFieldsChange = (field, value) => {
    setCampaignFormFields((prevFields) => ({
      ...prevFields,
      [field]: value,
    }));
  };

  const showConfirm = () => {
    onClose();
    setShowConfirmModel(true);
  };

  return (
    <>
      <Modal show={show} className="modal-delete" onHide={onClose} animation={true} centered>
        <Modal.Body>
          <CloseIcon handleModalClose={onClose} />
          <CampaignGreenIconSVG type="later" />
          <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
            Schedule for Later
          </Modal.Title>
          {/* <p>Schedule campaign for a later date</p> */}
          <Form.Group>
            <Form.Label>Date and Time</Form.Label>
            <Form.Control
              type="datetime-local"
              value={schedule_time}
              onChange={(evt) => handleCampaignFormFieldsChange('schedule_time', evt.target.value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Time Zone</Form.Label>
            <Select
              placeholder="Select Timezone.."
              className="custom-form-control"
              options={getTimezone()}
              value={timezone}
              onChange={(value) => handleCampaignFormFieldsChange('timezone', value)}
            />
          </Form.Group>
          <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
            <Button variant="ghost" style={{ minWidth: 160 }} onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              style={{ minWidth: 160 }}
              onClick={white_label_perkeso ? showConfirm : handleScheduleLater}
            >
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <SendScheduleConfirmModel
        show={showConfirmModel}
        onClose={() => setShowConfirmModel(false)}
        mode="schedule_later"
        handleScheduleLater={handleScheduleLater}
      />
    </>
  );
};

export default ScheduleModal;
